<template>
<div>
  <el-row style="margin-bottom: 10px;" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3">{{selectTitleName}}</div>
      <div class="setting-addel mr-l15">
        <el-button size="mini" @click="onClickAddButton"><i class="fas fa-plus" /></el-button>
        <el-button size="mini" :disabled="selectedSchedule.length < 1" @click="onClickDeleteButton"><i class="fas fa-minus" /></el-button>
      </div>
    </div>
    <div>
      <el-button type="success" size="mini" :disabled="selectedSchedule.length < 1" @click="onClickExecute(selectedSchedule)">일괄수행</el-button>
      <el-button type="primary" size="mini" :disabled="!changeFlag" @click="onSaveActiveFlag">저장</el-button>
      <el-button size="mini" :disabled="!changeFlag" @click="onClickCancelButton">취소</el-button>
      <el-button size="mini" @click="showSearchTool = !showSearchTool"><i class="fas fa-search" /></el-button>
    </div>
  </el-row>
  <el-table-wrapper style="width:100%" ref="scheduleTable" row-class-name="c-dblclick" :data="scheduleDataList" :columns="columns" :column-default="columnDefault" :show-custom-header="true" :show-search-tool="showSearchTool" :highlight-current-row="true"
    pagination remote :total="total" @condition-change="loadData" @selection-change="onSelectRow" @cell-dblclick="onDblclickCell">
    <template slot="active-slot" slot-scope="scope">
      <el-switch v-model="scope.row.activeFlag" active-value="Y" inactive-value="N" @change="checkModifiedData"/>
    </template>
    <template slot="progress-slot" slot-scope="scope">
      <el-progress :text-inside="true" :stroke-width="14" :percentage="scope.row.progressRate" />
    </template>
    <template slot="execute-slot" slot-scope="scope">
      <i class="fas fa-play-circle text-14 c-pointer" @click="onClickExecute(scope.row)"/>
    </template>
  </el-table-wrapper>

  <w-schedule-setting-popup ref="schedulePopup" :popupType="popupType" :showTarget="showTarget" :scheduleTypeId="activeTab" :configSchedule="configScheduleData" @loadData="loadData" @resetScheduleData="resetScheduleData" />
</div>
</template>

<script>
import moment from 'moment';
import { isEqual, cloneDeep, differenceWith, find, isNil, concat, forEach } from 'lodash';
import { columnDefault } from '@/constants/table';
import { isEmpty } from '@/utils/basic';
import { EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import msgUtil from '@/utils/message';
import ScheduleAPI from '@/api/settings/netdevice/schedule';
import WScheduleSettingPopup from '../popup/ScheduleSettingPopup';

export default {
  name: 'WScheduleView',
  components: {
    WScheduleSettingPopup,
  },
  props: {
    activeTab: String,
    activeFlag: Boolean,
  },
  data() {
    return {
      selectTitleName: '',
      showSearchTool: false,
      columnDefault,
      loading: false,
      columns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'activeFlag',
          label: '활성 여부',
          align: 'center',
          width: 80,
          scopedSlot: 'active-slot',
        },
        {
          prop: 'scheduleName',
          label: '스케줄명',
          sortable: true,
          width: 250,
          searchable: true,
          remoteProp: 'schedule_name',
        },
        {
          prop: 'schedulePeriod',
          label: '수행 주기',
          sortable: true,
          width: 100,
          searchable: true,
          remoteProp: 'schedule_period',
          formatter: this.formatSchedulePeriod,
        },
        {
          prop: 'scheduleContent',
          label: '상세 내용',
          sortable: true,
          searchable: true,
          remoteProp: 'schedule_content',
        },
        {
          prop: 'managerId',
          label: '등록자',
          sortable: true,
          width: 120,
          searchable: true,
          remoteProp: 'manager_id',
        },
        {
          prop: 'targetCount',
          label: '대상 장비 수',
          sortable: true,
          width: 100,
          formatter: this.formatObjCount,
        },
        {
          prop: 'lastScheduleDatetime',
          label: '최근 수행 일시',
          sortable: true,
          width: 150,
          formatter: this.formatScheduleDatetime,
        },
        {
          prop: 'lastScheduleDatetime',
          label: '다음 수행 일시',
          sortable: true,
          width: 150,
          formatter: this.formatNextScheduleDatetime,
        },
        {
          prop: 'progressRate',
          label: '진행률',
          sortable: true,
          scopedSlot: 'progress-slot',
          width: 100,
        },
        {
          label: '즉시수행',
          align: 'center',
          width: 70,
          scopedSlot: 'execute-slot',
        },
      ],
      originalScheduleDataList: [],
      scheduleDataList: [],
      selectedSchedule: [],
      changeFlag: false,
      configScheduleData: {},
      popupType: 'add',
      total: 0,
      executeScheduleIds: [],
      executeScheduleList: [],
      networkScheduleTask: 'networkScheduleTask',
    };
  },
  computed: {
    showTarget() {
      return (this.activeFlag && (this.activeTab !== 'CMPL_CHECK' && this.activeTab !== 'AUTO_TOPOLOGY'));
    },
    showTemplate() {
      return this.activeFlag && this.activeTab === 'EXEC_TEMPLATE';
    },
  },
  watch: {
    // scheduleDataList: {
    //   deep: true,
    //   handler() {
    //     this.changeFlag = !isEqual(this.originalScheduleDataList, this.scheduleDataList);
    //   },
    // },
    activeTab: {
      handler() {
        if (!isNil(this.activeTab)) {
          const tabName = this.activeTab;
          switch (tabName) {
            case 'SNMP_SCAN':
              this.selectTitleName = '구성정보 수집';
              break;
            case 'CMPL_CHECK':
              this.selectTitleName = '정책감사수행';
              break;
            case 'EXEC_TEMPLATE':
              this.selectTitleName = '스크립트 수행';
              break;
            case 'FAULT_CHECK':
              this.selectTitleName = '정기점검';
              break;
            case 'IP_SCAN':
              this.selectTitleName = 'IP대역 검색';
              break;
            case 'AUTO_TOPOLOGY':
              this.selectTitleName = '연결정보 수집';
              break;
            default:
              this.selectTitleName = '구성정보 수집';
          }
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.$taskManager.existTask(this.networkScheduleTask)) {
      this.$taskManager.removeTask(this.networkScheduleTask);
    }
  },
  methods: {
    /**
     * 최종 수행 일시를 YYYY-MM-DD HH:mm:ss 형식으로 변환한다.
     * @return {[type]} [description]
     * @author jda
     */
    formatScheduleDatetime(row, column, value) {
      if (isEmpty(value)) {
        return EMPTY_TEXT;
      }
      return getDateToString(value);
    },
    /**
     * 수행 주기를 한글 형태로 변환한다.
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    formatSchedulePeriod(row, column, value) {
      if (value === 'N') {
        return '한번';
      } else if (value === 'D') {
        return '매일';
      } else if (value === 'W') {
        return '매주';
      } else if (value === 'M') {
        return '매월';
      }
      return EMPTY_TEXT;
    },
    /**
     * 대상 장비의 개수를 리턴한다.
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    formatObjCount(row, column, value) {
      if (this.activeTab === 'CMPL_CHECK') {
        return `${row.deviceCount}대`;
      }
      return `${value}대`;
    },
    /**
     * 다음 수행 일시를 계산하다.
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    formatNextScheduleDatetime(record, column, value) {
      const period = record.schedulePeriod;
      if (period === 'N') {
        if (new Date() < new Date(record.scheduleStarttime)) {
          return getDateToString(record.scheduleStarttime);
        }
        return EMPTY_TEXT;
      } else if (period === 'D') {
        let nextTime = new Date().setHours(record.scheduleHour, record.scheduleMinute, 0, 0);

        if (nextTime < new Date()) {
          nextTime = moment(nextTime).add(1, 'days');
        }
        return getDateToString(nextTime);
      } else if (period === 'W') {
        const datetime = isEmpty(value) || new Date(value) < new Date() ? new Date() : new Date(value);

        const dates = record.scheduleIntervalDate.split(',');
        // 일요일 : moment - 0, java calendar: 1 -> 따라서 moment+1 = calendar의 요일
        const currentDate =
          moment(datetime)
            .clone()
            .day() + 1;
        const nextDate = find(dates, (date) => date > currentDate);
        const nextDay = parseInt(nextDate, 10) - 1; // moment사용으로 -1

        let nextTime = moment(datetime)
          .clone()
          .set({
            day: nextDay,
          })
          .toDate();

        if (nextTime < new Date()) {
          nextTime = moment()
            .add(1, 'weeks')
            .startOf('week')
            .set({
              day: parseInt(dates[0], 10) - 1,
            });
        } else if (moment().day() > nextDay) {
          nextTime = moment()
            .add(1, 'weeks')
            .startOf('week')
            .set({
              day: nextDay,
            });
        } else {
          nextTime = moment()
            .startOf('week')
            .set({
              day: nextDay,
            });
        }
        nextTime = nextTime.toDate().setHours(record.scheduleHour, record.scheduleMinute, 0, 0);
        return getDateToString(nextTime);
      } else if (period === 'M') {
        const datetime = isEmpty(value) || new Date(value) < new Date() ? new Date() : new Date(value);
        const months = record.scheduleIntervalMonth.split(',');
        const dates = record.scheduleIntervalDate.split(',');

        const currentMonth = datetime.getMonth() + 1;
        let nextMonth = parseInt(find(months, (month) => month >= currentMonth), 10);

        const currentDate = datetime.getDate();
        let nextDate = find(dates, (date) => date > currentDate);

        if (nextMonth > currentMonth) {
          nextDate = dates[0];
        }

        if (isEmpty(nextDate)) {
          nextMonth = months[months.indexOf(nextMonth.toString()) + 1];
          nextDate = dates[0];
        }

        let nextTime = moment(datetime).set({
          month: nextMonth - 1,
          date: nextDate,
          hour: record.scheduleHour,
          minute: record.scheduleMinute,
          second: 0,
        });
        if (nextMonth < currentMonth) {
          nextTime = nextTime.add(1, 'years');
        }
        return getDateToString(nextTime.toDate());
      }
      return EMPTY_TEXT;
    },
    /**
     * [수집 주기 추가] 팝업창을 띄운다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickAddButton() {
      this.popupType = 'add';
      this.$refs.schedulePopup.open();
    },
    /**
     * 수집 주기 목록을 조회한다.
     * @return {[type]} [description]
     * @author jda
     */
    loadData() {
      this.scheduleDataList = [];
      this.total = 0;
      const tableParams = this.$refs.scheduleTable.getParameter();
      this.loading = true;
      ScheduleAPI.getNetdeviceScheduleList({
        scheduleTypeId: this.activeTab,
        ...tableParams,
      }).then((response) => {
        if (response.data.success) {
          const result = response.data.data;
          this.originalScheduleDataList = cloneDeep(result);
          this.scheduleDataList = result;
          this.total = response.data.total;
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '스케줄', false));
        }
      }).catch(() => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '스케줄', false));
      }).finally(() => {
        this.loading = false;
      });
    },
    /**
     * 수집 주기를 선택한다.
     * @param  {[type]} selection [description]
     * @return {[type]}           [description]
     * @author jda
     */
    onSelectRow(selection) {
      this.selectedSchedule = selection;
    },
    /**
     * 수집 주기릃 삭제한다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickDeleteButton() {
      if (this.selectedSchedule.length < 1) {
        return;
      }

      this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE))
        .then(() => {
          ScheduleAPI.deleteNetdeviceSchedule(this.selectedSchedule).then((response) => {
            if (response.data.success) {
              this.loadData();
            }
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '스케줄', response.data.success));
          }).finally(() => {
            if (this.activeTab === 'AUTO_TOPOLOGY') {
              this.$mapEventBus.$emit('tree_load');
            }
          });
        })
        .catch(() => {});
    },
    /**
     * [활성 여부]를 저장한다.
     * @return {[type]} [description]
     * @author jda
     */
    onSaveActiveFlag() {
      const modifyRecords = differenceWith(this.scheduleDataList, this.originalScheduleDataList, isEqual);
      ScheduleAPI.updateNetdeviceSchedule(modifyRecords).then((response) => {
        if (response.data.success) {
          this.loadData();
        }
        this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '활성 여부', response.data.success));
      });
    },
    /**
     * [취소]버튼 클릭시 원래 수집 주기 목록 데이터를 로드한다.
     * @return {[type]} [description]
     * @author jda
     */
    onClickCancelButton() {
      this.scheduleDataList = cloneDeep(this.originalScheduleDataList);
    },
    /**
     *  record 더블 클릭 시 선택한 수집 주기를 편집할 수 있는 팝업창을 띄운다.
     * @param  {[type]} record [description]
     * @param  {[type]} column [description]
     * @return {[type]}        [description]
     * @author jda
     */
    onDblclickCell(record, column) {
      if (isEmpty(column.property) || column.property === 'activeFlag') {
        return;
      }

      this.popupType = 'edit';
      this.configScheduleData = record;
      this.$refs.schedulePopup.open();
    },
    /**
     * 스케쥴을 수행한다.
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    onClickExecute(record) {
      const scheduleList = Array.isArray(record) ? record : [record];
      ScheduleAPI.executeSchedule(scheduleList).then((res) => {
        if (res.data.success) {
          const newScheduleList = [];
          const newScheduleIds = [];

          forEach(scheduleList, (item) => {
            if (this.executeScheduleIds.indexOf(item.scheduleId) < 0) {
              this.$message(msgUtil.getResultMsgData('시작', '스케쥴 수행', true));
              newScheduleList.push(item);
              newScheduleIds.push(item.scheduleId);
            }
          });
          this.executeScheduleList = concat(this.executeScheduleList, newScheduleList);
          this.executeScheduleIds = concat(this.executeScheduleIds, newScheduleIds);

          this.$taskManager.createTask(
            this.networkScheduleTask,
            1,
            () => {
              ScheduleAPI.getScheduleInfoById(this.executeScheduleIds).then((response) => {
                if (response.data.success) {
                  const result = response.data.data;
                  if (result.length < 1) {
                    this.$taskManager.removeTask(this.networkScheduleTask);
                    this.executeScheduleIds = [];
                    this.executeScheduleList = [];
                    this.loadData();
                    this.$message(msgUtil.getResultMsgData('완료', '스케쥴 수행', true));
                  } else {
                    const noCompletedScheduleList = [];
                    const noCompletedScheduleIds = [];
                    forEach(this.executeScheduleList, (item) => {
                      let completeFlag = true;
                      for (let i = 0; i < result.length; i += 1) {
                        if (item.scheduleId === result[i].scheduleId) {
                          item.progressRate = result[i].progressRate;
                          noCompletedScheduleList.push(item);
                          noCompletedScheduleIds.push(item.scheduleId);
                          completeFlag = false;
                          break;
                        }
                      }
                      if (completeFlag) {
                        item.progressRate = 100;
                      }
                    });

                    this.executeScheduleIds = noCompletedScheduleIds;
                    this.executeScheduleList = noCompletedScheduleList;
                  }
                }
              });
            },
            false,
            300,
            () => {
              this.$taskManager.removeTask(this.networkScheduleTask);
              this.loadData();
              this.$message(msgUtil.getCustomResultMsgData('시간 초과로 스케쥴 수행 결과를 확인하지 못하였습니다.', false));
            },
          );
          this.$taskManager.startTask(this.networkScheduleTask);
        }
      });
    },
    /**
     * 수집 주기 편집 스케쥴 데이터 초기화
     * @author jda
     */
    resetScheduleData() {
      this.configScheduleData = {};
    },
    /**
     * 데이터 변경 여부를 확인한다.
     * @author Ju
     * @return {[type]} [description]
     */
    checkModifiedData() {
      this.changeFlag = !isEqual(this.originalScheduleDataList, this.scheduleDataList);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/ScheduleSettings/NetworkScheduleSettings/components/table/ScheduleTable.vue